/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

modulum("FilterService", ["InitService", "MainContainerService"], function (context, cls) {
  /**
   * Service responsible of any Filter located in the chrome bar
   * This search bar can be used as a filter for array
   * @namespace gbc.FilterService
   * @gbcService
   * @publicdoc
   */
  class FilterService /** @lends gbc.FilterService */ {
    constructor() {
      /**
       * The search bar follow a singleton pattern
       * if it already exists, it must be in DOM
       * and any new invocation will just return the widget
       * @type {classes.FilterWidget}
       */
      this._filterWidget = null;

      /**
       * A search value that can be set before invoking the search bar
       */
      this._searchValue = "";
    }

    init() {
      this._eventListener = new cls.EventListener();
    }

    destroy() {
      this.destroyFilter();
    }

    /**
     * Return the current filter widget.
     * Or null if the widget is not on screen
     * @returns {classes.FilterWidget}
     */
    getFilter() {
      return this._filterWidget;
    }

    /**
     * Create a search bar if needed.
     * And add it in DOM. Then return the reference to it
     * @return {classes.FilterWidget}
     */
    invokeFilter() {
      if (this._filterWidget) {
        return this._filterWidget;
      }
      this._filterWidget = cls.WidgetFactory.createWidget("Filter", {
        appHash: gbc.systemAppId
      });
      context.MainContainerService.getMainContainer().append(this._filterWidget.getElement());
      this._filterWidget.onClose(this.destroyFilter.bind(this));
      this._filterWidget.onValueChanged(this._onFilterUpdateValue.bind(this));
      this._filterWidget.setValue(this._searchValue);
      this._eventListener.emit("filterWidget.destroy");
      return this._filterWidget;
    }

    /**
     * Destroy the search bar widget
     * Remove it from the DOM
     * and destroy the reference
     */
    destroyFilter() {
      this._filterWidget.destroy();
      this._filterWidget = null;
      this._eventListener.emit("filterWidget.destroy");
    }

    /**
     * Store the value and apply it to the search bar
     * if the search bar is not in DOM, the value
     * will be applied when invoking the Search Bar
     * @param {string} value
     */
    setValue(value) {
      this._searchValue = value;
      this._filterWidget?.setValue(this._searchValue);
    }

    /**
     * Event triggered when the filter value is modified
     * by the user or by the program
     * @param {*} event
     * @param {classes.EventListener} invoker
     * @param {string} value Current filter widget value
     */
    _onFilterUpdateValue(event, invoker, value) {
      this._searchValue = value;
      const app = gbc.SessionService.getCurrent() && gbc.SessionService.getCurrent().getCurrentApplication();
      const focusedNode = app.getFocusedVMNodeAndValue(true);
      const nodeWithFilter = focusedNode.isAttributePresent("filter") ? focusedNode : focusedNode.getAncestorWithAttribute("filter");
      const filterCurrentValue = nodeWithFilter.attribute("filter");
      if (value === filterCurrentValue) {
        return;
      }
      const vmEvent = new cls.VMConfigureEvent(nodeWithFilter.getId(), {
        filter: value
      });
      app.scheduler.eventVMCommand(vmEvent, focusedNode);
    }
  }
  gbc.FilterService = new FilterService();
  context.InitService.register(context.FilterService);
});
